export const OS_STATUS = [
  { value: "solicitada", label: "Solicitada", cls: "bg-[#ECEAE4] text-[#4A4A4A]" },
  { value: "agendada", label: "Agendada", cls: "bg-[#E1F0FA] text-[#015F8C]" },
  { value: "em_deslocamento", label: "Em deslocamento", cls: "bg-[#FEF3C7] text-[#92400E]" },
  { value: "em_atendimento", label: "Em atendimento", cls: "bg-[#E8F5E9] text-[#1E4D2B]" },
  { value: "aguardando_peca", label: "Aguardando peça", cls: "bg-[#FDE7DD] text-[#9A3412]" },
  { value: "aguardando_aprovacao", label: "Aguardando aprovação", cls: "bg-[#F5E6E0] text-[#8C3F28]" },
  { value: "finalizada", label: "Finalizada", cls: "bg-[#1E4D2B] text-white" },
  { value: "nao_concluida", label: "Não concluída", cls: "bg-[#B05A40] text-white" },
];

export const statusInfo = (v) => OS_STATUS.find((s) => s.value === v) || OS_STATUS[0];

export const nextStatus = (v) => {
  const flow = OS_STATUS.filter((s) => s.value !== "nao_concluida");
  const i = flow.findIndex((s) => s.value === v);
  return i >= 0 && i < flow.length - 1 ? flow[i + 1] : null;
};

export const StatusBadge = ({ status, testId }) => {
  const s = statusInfo(status);
  return <span className={`text-xs font-bold px-2.5 py-1 rounded-full whitespace-nowrap ${s.cls}`} data-testid={testId}>{s.label}</span>;
};
